import {
  formIsValidatedFalse,
  getFormElement,
  getRequiredFormFields, initDeactivateAlertButtons, initInvalidateButton, initValidateButton,
  inlineValidationRequest, submitForm
} from "../components/form/form.js";

export function initForm(selector = 'form') {
  const formElement = getFormElement(selector);
  if (!formElement) return;

  const requiredFormFields = getRequiredFormFields(formElement),
    validateButton = formElement ? formElement.querySelector('button.validate') : false,
    invalidateButton = formElement ? formElement.querySelector('button.invalidate') : false

  formElement.addEventListener('submit', e => {
    e.preventDefault();

    requiredFormFields.forEach(input => {
      inlineValidationRequest(formElement, input, false)

    });

    submitForm(formElement);
  })

  if (validateButton) initValidateButton(formElement, validateButton);
  if (invalidateButton) initInvalidateButton(formElement, invalidateButton);

  requiredFormFields.forEach(requiredFormField => {
    requiredFormField.addEventListener('input', () => {

      if (formIsValidatedFalse(formElement)) formElement.removeAttribute('data-valid-form');
      inlineValidationRequest(formElement, requiredFormField, true);
    });
  });

  initDeactivateAlertButtons(formElement);

  document.addEventListener('successfulFormSubmit', e => {
    const formId = e.detail.formId,
      formTitle = e.detail.formTitle;

    if (formId || formTitle) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'formSubmission',
        'formID': formId,
        'formTitle': formTitle
      });
    }
  })
}
